import React from 'react';

const timers = {
    timeout: {
        set: setTimeout.bind(global),
        clear: clearTimeout.bind(global),
    },
    interval: {
        set: setInterval.bind(global),
        clear: clearInterval.bind(global),
    },
};
function useTimer(cb, delay, timer) {
    const cbRef = React.useRef<() => undefined>();
    React.useEffect(() => {
        cbRef.current = cb;
    });

    React.useEffect(() => {
        function tick() {
            cbRef.current();
        }
        const timerId = timer.set(tick, delay);
        return () => timer.clear(timerId);
    }, [delay]);
}
export function useTimeout(cb, delay) {
    useTimer(cb, delay, timers.timeout);
}

export function useInterval(cb, delay) {
    useTimer(cb, delay, timers.interval);
}
